import React from "react";
import { Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function DividerComponent({ size = "md" }) {
	const theme = useTheme();
	let st = {};
	if (size === "lg" || size === "xl") {
		st = {
			borderColor: theme.palette.grey.darker,
			borderBottomWidth: "2px",
			marginY: theme.spacing(size === "lg" ? 2 : 4),
		};
	}
	return <Divider sx={st} />;
}

export default DividerComponent;
